import React, { useEffect } from "react";

// Shared off-canvas mobile navigation drawer — same pattern used on the public
// Guest/Host landing pages (slide-in panel + dimmed overlay, Escape/overlay/link
// to close). Callers supply their own link list as children.
const MobileNavSidebar = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    document.body.classList.toggle('sidebar-open', isOpen);
    return () => document.body.classList.remove('sidebar-open');
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <>
      <div
        className={`nav-sidebar-overlay${isOpen ? ' active' : ''}`}
        onClick={onClose}
      />
      <aside className={`nav-sidebar${isOpen ? ' open' : ''}`} aria-label="Navigation menu">
        <div className="nav-sidebar-header">
          <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="Simply Halls" style={{ maxHeight: 45, width: 'auto' }} />
          <button className="nav-sidebar-close" onClick={onClose} aria-label="Close menu">&times;</button>
        </div>
        <div className="nav-sidebar-body">
          {children}
        </div>
      </aside>
    </>
  );
};

export default MobileNavSidebar;
